// extracted by mini-css-extract-plugin
export default {"menu_container":"Menu_menu_container__OpERl","menu":"Menu_menu__l5-dq"};